export class ChartConfigEnvironment {
  public static getName = () => 'benzinga-chart-config';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://pro-charts.benzinga.com/tradingview/'),
  });
}
